export * from './tc-layout/tc-layout.module';

/*Dumb components*/
export * from './tc-layout/components/dumb/tc-layout/tc-layout.component';
export * from './tc-layout/components/dumb/tc-panel/tc-panel.component';
